export default __webpack_public_path__ + "static/dreifaltigkeit-2-51932ea1028a7721d8686b1e75c950a0.png";